import React, { useState, useEffect } from 'react'
import { Tabs, Tab } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CenteredLayout } from './shared/CenteredLayout'
import Details from '../components/userConfiguration/permissionGroups/permissionGroup/Details'
import Members from '../components/userConfiguration/permissionGroups/permissionGroup/Members'
import Rules from '../components/userConfiguration/permissionGroups/permissionGroup/Rules'
import { ContentTitle } from '../components/shared/ContentTitle'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import { routingConstants } from '../constants/routing.constants'

const useStyles = makeStyles(() => ({
    tabs: {
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        marginBottom: '10px',
    },
    bodySection: {
        marginBottom: '30px',
    },
}))

export function RolePermissionGroupConfigurationPage() {
    const history = useHistory()
    const { rolePermissionGroupId } = useParams()
    const classes = useStyles()
    const tabValues = {
        DETAILS: 0,
        MEMBERS: 1,
        RULES: 2,
    }

    const [tabValue, setTabValue] = useState(tabValues.DETAILS)

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    useEffect(() => {
        ;(async () => {
            console.log('permission group loaded ', rolePermissionGroupId)
            // try {
            //     await getEventDetails(eventId).then(response => {
            //         setFormState(response)
            //     })
            // } catch (exception) {
            //     dispatch(
            //         enqueueSnackbar({
            //             message: 'Error getting Event details',
            //             options: { variant: 'error' },
            //         })
            //     )
            // }
        })()
    }, [rolePermissionGroupId])

    const TabView = () => {
        switch (tabValue) {
            case tabValues.DETAILS:
                return <Details rolePermissionGroupId={rolePermissionGroupId} />
            case tabValues.MEMBERS:
                return <Members rolePermissionGroupId={rolePermissionGroupId} />
            case tabValues.RULES:
                return <Rules rolePermissionGroupId={rolePermissionGroupId} />
            default:
                return <Details rolePermissionGroupId={rolePermissionGroupId} />
        }
    }

    const handleBackButtonClick = () => {
        history.push(routingConstants.paths.userConfiguration)
    }

    return (
        <CenteredLayout>
            <ContentTitle
                pageTitle={`Role Permission Group`}
                actionButtonText={'Back'}
                onActionButtonClick={handleBackButtonClick}
            />

            <div
                style={{ justifyContent: 'center' }}
                className={classes.topBarSection}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor='secondary'
                    textColor='secondary'
                    variant='fullWidth'
                    className={classes.tabs}>
                    <Tab label='Details' />
                    <Tab label='Members' />
                    <Tab label='Rules' />
                </Tabs>
            </div>
            <div className={classes.bodySection}>
                <TabView />
            </div>
        </CenteredLayout>
    )
}
